import { Box, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BasicAccountSettingsBox = function BasicAccountSettingsBox(_ref) {
  var questionRef = _ref.questionRef,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(Box, {
    ref: questionRef,
    sx: {
      mb: 4
    },
    "data-element": "Box",
    "data-component": "BasicAccountSettingsBox",
    "data-source-file": "basic-account-settings-box.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      sx: {
        mb: 3
      },
      variant: "h2",
      "data-element": "Typography",
      "data-component": "BasicAccountSettingsBox",
      "data-source-file": "basic-account-settings-box.tsx",
      children: /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "BasicAccountSettingsBox",
        "data-source-file": "basic-account-settings-box.tsx",
        children: function children(t) {
          return t('Account settings');
        }
      })
    }), children]
  });
};